module.exports = __webpack_public_path__ + "img/product-12.670076ce.jpg";